export const mapsUrl = (args: { latitude: string; longitude: string }) =>
  `https://www.google.com/maps?q=${args.latitude},${args.longitude}`;

export const mapLinkHandler = (args: { latitude: string; longitude: string; label: string }) => {
  const { latitude, longitude, label } = args;

  const isAndroid = /android/i.test(navigator.userAgent);
  const geoUri = `geo:${latitude},${longitude}?q=${label ? encodeURIComponent(label) : ''}`;

  isAndroid ? (window.location.href = geoUri) : window.open(mapsUrl({ latitude, longitude }), '_blank');
};
